import { Button, type ButtonProps } from "@chakra-ui/react";

type Props = {
  active?: boolean;
  borderPos?: "top" | "bottom";
} & ButtonProps;

export function TabButton(props: Props) {
  const { active, borderPos = "bottom", children, ...rest } = props;

  return (
    <Button
      borderBottom={borderPos === "bottom" ? "3px solid" : undefined}
      borderTop={borderPos === "top" ? "3px solid" : undefined}
      borderColor={active ? "brand.500" : "transparent"}
      borderRadius={0}
      backgroundColor={"transparent"}
      _hover={{ bgColor: "gray-base-03" }}
      _active={{ bgColor: "gray-base-04" }}
      color={active ? "text-base-01" : "text-base-02"}
      alignItems={"center"}
      gap={1}
      {...rest}
    >
      {children}
    </Button>
  );
}
